import { Club } from '@/interfaces/club';
import { ClubResource, clubResource } from '@/resources/club.resource';
import offers from './club/offers.module';
import { EntityModule } from './entity.module';

/**
 * Moduł klubu
 *
 * @export
 * @class ClubModule
 * @extends { EntityModule<Club, ClubResource> }
 */
export class ClubModule extends EntityModule<Club, ClubResource> {
  /**
   * Moduły klubu
   *
   * @memberof ClubModule
   */
  public modules = { offers };
  constructor() {
    super(clubResource);
  }
}

export default new ClubModule();
